import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

// Every review written *about* one member in one cycle (awards-service
// GOTU-7230) — received, never given, the same asymmetry the roster's
// hasFeedback tick already pins. Unpaginated: at most one review per reviewer
// per member per cycle. A member nobody reviewed is a 200 with an empty array.
export const getMemberReceivedFeedback = async (cycleId, userId) => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get(
    `/awards-service-api/admin/cycles/${cycleId}/memberships/${userId}/feedback`,
    { headers },
  );

  return response.data;
};
